module.exports = __webpack_public_path__ + "screenshot.1e15894113e6053bdb32590c1cf15f71.png";